import React, { FC } from 'react';
import { getProductionBatchByProductionOrderId, productionOrdersSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { NCFileSearchItem } from '@interfaces/search';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { getNCFilesByProductionOrderId } from '@reducers/manufacture';
import Times from '@v2/context/Times/page';
import { scale } from '@components/frame';
import { SCREEN_PADDING_HORIZONTAL_FOR_ITEM, SCREEN_PADDING_HORIZONTAL_FOR_PAGE } from '@v2/pages/common/constants/base.constants';
import { ProductionOrderScreenProps } from '@v2/pages/productionOrder/common/interfaces';
import { useProductionOrderDetails } from '@v2/pages/common/hooks/useProductionOrderDetails';
import { loadSingleBatch } from '@reducers/batch';

interface ProductionOrderDetailsNCFileTimesProps extends ProductionOrderScreenProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
}

const ProductionOrderDetailsNCFileTimesComponent: FC<ProductionOrderDetailsNCFileTimesProps> = ({
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
  productionOrdersSearch,
  ncFileData,
}) => {
  const title = useTitle();

  useProductionOrderDetails({
    productionOrdersSearch,
    getNCFilesByProductionOrderId,
    getProductionBatchByProductionOrderId,
    loadSingleBatch,
    updateHeaderConfig,
    getAllNcFiles: true,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <Times
        withoutPaddingHorizontal
        ncFileId={ncFileData?.data?.ncFileId}
        style={{ paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL_FOR_ITEM) }}
        horizontalOffset={SCREEN_PADDING_HORIZONTAL_FOR_PAGE * 2}
      />
    </DetailsPageWrapper>
  );
};

const ProductionOrderDetailsNCFileTimes = connect(({ details: { ncFileData } }) => ({ ncFileData }), {
  productionOrdersSearch,
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
})(ProductionOrderDetailsNCFileTimesComponent);

export { ProductionOrderDetailsNCFileTimes };
